import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const ContactComponent = dynamic(() => import('./ContactComponent'));

const ContactComponentConfig = {
  name: 'ContactComponent',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Enter Title...',
    },
    {
      name: 'content',
      type: 'richText',
      defaultValue: 'Enter content here...',
    },
    {
      name: 'isMarketingPreferences',
      friendlyName: 'Is Marketing Preferences',
      type: 'boolean',
      defaultValue: false,
    },
  ],
};

Builder.registerComponent(ContactComponent, ContactComponentConfig);
